import { apiGet, apiPost, apiDelete } from './client';

export interface Relationship {
  id: string;
  organization_id: string;
  subject_principal_id: string;
  relation_name: string;
  object_resource_id: string;
  created_by_user_id: string | null;
  created_at: string;
}

export interface CreateRelationshipRequest {
  subject_principal_id: string;
  relation_name: string;
  object_resource_id: string;
}

export interface ListRelationshipsParams {
  subject_id?: string;
  relation?: string;
  object_id?: string;
  page?: number;
  per_page?: number;
}

export interface ListRelationshipsResponse {
  data: Relationship[];
  meta: { pagination: { page: number; per_page: number; total: number; total_pages: number } };
}

export async function listRelationships(
  params?: ListRelationshipsParams,
): Promise<ListRelationshipsResponse> {
  const query: Record<string, string | number | undefined> = {};
  if (params?.subject_id !== undefined) query['subject_id'] = params.subject_id;
  if (params?.relation !== undefined) query['relation'] = params.relation;
  if (params?.object_id !== undefined) query['object_id'] = params.object_id;
  if (params?.page !== undefined) query['page'] = params.page;
  if (params?.per_page !== undefined) query['per_page'] = params.per_page;
  return apiGet<ListRelationshipsResponse>(
    '/relationships',
    Object.keys(query).length > 0 ? query : undefined,
  );
}

export async function createRelationship(
  data: CreateRelationshipRequest,
): Promise<Relationship> {
  return apiPost<Relationship>('/relationships', data);
}

export async function deleteRelationship(id: string): Promise<void> {
  return apiDelete<void>(`/relationships/${id}`);
}
